import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useSuppliers = () => useQuery({ queryKey: ['suppliers'], queryFn: async () => {
    const callback = await API.get(`/common/products/suppliers`)
    return callback?.data
}})

export default useSuppliers